module.exports = __webpack_public_path__ + "static/media/dmt_nav.76b5a3f3.svg";